import { api } from "../ConsumeApiController"; 
import CustomerRoutes from "../../apiRoutes/CustomerRoutes";

/**
 * Obtiene los pedidos paginados y filtrados
 * @param {string} group - 'all', 'active', 'history', 'pending'
 * @param {number} page - Número de página (1, 2, 3...)
 */
export const getMyOrders = async (group = 'all', page = 1) => {
    try {
        const url = CustomerRoutes.Orders.MyOrders(group,page);
        const response = await api.get(url);
        console.log('ORDER RESPONSE ===> ',response);
        const payload = response.data;

        return {
            success: true,
            data: payload.data, // <--- Accedemos al array de pedidos
            meta: payload.meta  // <--- Accedemos a la info de paginación
        };

    } catch (error) {
        console.error("Error fetching orders:", error);
        return { success: false, data: [], meta: null };
    }
};


/**
 * Obtiene el detalle de un pedido específico por ID.
 * @param {number|string} orderId 
 */
export const getOrderDetails = async (orderId) => {
    try {
        const url = CustomerRoutes.Orders.Detail(orderId);
        const response = await api.get(url);
        
        // response.data = { success: true, data: { id: 105, items: [...] }, message: '...' }
        return response; 
    } catch (error) {
        console.error("Error fetching order details:", error);
        return { 
            success: false, 
            message: error.response?.data?.message || 'Error al cargar el pedido.' 
        };
    }
};